module.exports = __webpack_public_path__ + "media/feature-icons/Gps-0fc37e97.svg";